import { AnimationCallbackEvent } from '@angular/core';
import { FuseAnimationCurves, FuseAnimationDurations } from '@fuse/animations/defaults';

// -----------------------------------------------------------------------------------------------------
// @ Expand / collapse
// -----------------------------------------------------------------------------------------------------
// For (animate.enter) and (animate.leave). A height to or from `auto` cannot be written as a CSS
// keyframe, so these measure the element and run the animation through the Web Animations API.

const timing: KeyframeAnimationOptions = {
    duration: parseInt(FuseAnimationDurations.entering, 10),
    easing  : FuseAnimationCurves.deceleration,
};

/** Grow the entering element from no height to its natural height. */
export function fuseExpand(event: AnimationCallbackEvent): void
{
    const element = event.target as HTMLElement;

    element.animate([{height: '0px'}, {height: `${element.scrollHeight}px`}], timing)
        .finished.then(event.animationComplete, event.animationComplete);
}

/** Shrink the leaving element to no height before it is removed. */
export function fuseCollapse(event: AnimationCallbackEvent): void
{
    const element = event.target as HTMLElement;

    element.animate([{height: `${element.offsetHeight}px`}, {height: '0px'}], {...timing, fill: 'forwards'})
        .finished.then(event.animationComplete, event.animationComplete);
}
